module.exports = __webpack_public_path__ + "static/img/empty-table.bb123b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/APRILYOS/empty-table.png
// module id = HGAj
// module chunks = 0